import React, { useState } from 'react';

// Function to get the date of the last 7 days including the current day
const getLast7Days = () => {
    const days = [];
    for (let i = 6; i >= 0; i--) {
        const date = new Date();
        date.setDate(date.getDate() - i);
        days.push(date);
    }
    return days;
};

const DayCard = ({ date, isSelected, onClick }) => {
    // Format the day of the week and day of the month
    const dayOfWeek = date.toLocaleString('en-US', { weekday: 'short' }); // 3 letter day name
    const dayOfMonth = date.getDate().toString().padStart(2, '0'); // Day with leading 0 for single digit

    return (
        <div
            style={{
                ...styles.dayCard,
                backgroundColor: isSelected ? '#333' : 'transparent', // Dark background when selected
                color: isSelected ? 'white' : 'black', // White text when selected
            }}
            onClick={() => onClick(date)}
        >
            <div style={styles.dayOfWeek}>{dayOfWeek}</div>
            <div style={styles.dayOfMonth}>{dayOfMonth}</div>
        </div>
    );
};

const DaysContainer = () => {
    const last7Days = getLast7Days();

    const [selectedDay, setSelectedDay] = useState(last7Days[6]); // Initially select the last (current) day

    const handleDayClick = (date) => {
        setSelectedDay(date); // Set the clicked day as selected
    };

    return (
        <div style={styles.container}>
            {last7Days.map((date, index) => (
                <DayCard
                    key={index}
                    date={date}
                    isSelected={date.toDateString() === selectedDay.toDateString()} // Check if the day is selected
                    onClick={handleDayClick}
                />
            ))}
        </div>
    );
};

const styles = {
    container: {
        display: 'grid',
        gridTemplateColumns: 'repeat(7, 1fr)', // 7 equal columns
        gap: '5px',
        justifyContent: 'center',
        alignItems: 'center',
    },
    dayCard: {
        padding: '5px',
        borderRadius: '8px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
    },
    dayOfWeek: {
        fontSize: '12px',
        fontWeight: 'normal',
        color: '#d3d1d1',
    },
    dayOfMonth: {
        fontSize: '20px',
        fontWeight: 'normal',
    },
};

export default DaysContainer;
